import groq from 'groq';

import { ASSET } from './asset';

const REBUS_HERO_PROJECTION = groq`{
    _key,
    _type,
    children,
    style,
    markDefs[] {
      _key,
      _type,
      _type == "inlineImage" => {
        image {
          ${ASSET}
        }
      }
    }
  }
`;

export const REBUS_HERO = groq`hero[] ${REBUS_HERO_PROJECTION}`;

export const CAMPAIGN_REBUS_HERO = groq`"rebusHero": rebusHero[] ${REBUS_HERO_PROJECTION}`;
